import { render, staticRenderFns } from "./GoogleButtonV2.vue?vue&type=template&id=0e049c6b&scoped=true&"
import script from "./GoogleButtonV2.vue?vue&type=script&lang=js&"
export * from "./GoogleButtonV2.vue?vue&type=script&lang=js&"
import style0 from "./GoogleButtonV2.vue?vue&type=style&index=0&id=0e049c6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e049c6b",
  null
  
)

export default component.exports